export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      3815.3287981859407,
    ],
    button_spin: [
      5000,
      1473.015873015873,
    ],
    end_free_spin: [
      8000,
      3295.782312925169,
    ],
    free_bet_big_win: [
      13000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      16000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      20000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      22000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      25000,
      40028.29931972789,
    ],
    free_spin_music: [
      67000,
      60001.81405895691,
    ],
    free_spin_popup: [
      129000,
      3461.22448979591,
    ],
    free_spin_start: [
      134000,
      2401.8140589569157,
    ],
    inside_buttons: [
      138000,
      370.06802721089116,
    ],
    main_ambient: [
      140000,
      46392.018140589586,
    ],
    main_music: [
      188000,
      119999.27437641725,
    ],
    mega_win: [
      309000,
      4337.777777777774,
    ],
    mult_x1: [
      315000,
      1060.8616780045281,
    ],
    mult_x3: [
      318000,
      1142.1315192743577,
    ],
    mult_x5: [
      321000,
      1124.7165532879535,
    ],
    mult_x7: [
      324000,
      1110.2040816326735,
    ],
    mult_x9: [
      327000,
      1568.7981859410343,
    ],
    outside_buttons: [
      330000,
      576.145124716561,
    ],
    reel_spin: [
      332000,
      1830.0226757369842,
    ],
    reel_stop_01: [
      335000,
      120.45351473921073,
    ],
    reel_stop_02: [
      337000,
      114.64852607707599,
    ],
    reel_stop_03: [
      339000,
      137.86848072561497,
    ],
    reel_stop_04: [
      341000,
      137.86848072561497,
    ],
    reel_stop_05: [
      343000,
      123.3560090702781,
    ],
    regular_win: [
      345000,
      1084.0816326530671,
    ],
    scatter_chance: [
      348000,
      4749.931972789113,
    ],
    scatter_stop: [
      354000,
      1394.6485260771055,
    ],
    tap_to_play: [
      357000,
      4999.546485260794,
    ],
    ultra_win: [
      363000,
      3835.6462585034024,
    ],
  },
}
